import React, { useEffect} from "react";
import { BiPlusCircle } from "react-icons/bi";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Breadcrumb from "../common/Breadcrumb";

const BiologyPhoto = () => {  

  const images = [
    { id: 1, src: "images/gallery/biology-7.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 2, src: "images/gallery/biology-8.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 3, src: "images/gallery/biology-9.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 4, src: "images/gallery/biology-10.png", alt: "Biology", title: "Biology", group: "Biology" },  
    { id: 5, src: "images/gallery/biology-11.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 6, src: "images/gallery/biology-12.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 7, src: "images/gallery/biology-13.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 8, src: "images/gallery/biology-14.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 9, src: "images/gallery/biology-15.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 10, src: "images/gallery/biology-16.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 11, src: "images/gallery/biology-17.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 12, src: "images/gallery/biology-18.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 13, src: "images/gallery/biology-19.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 14, src: "images/gallery/biology-20.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 15, src: "images/gallery/biology-21.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 16, src: "images/gallery/biology-22.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 17, src: "images/gallery/biology-23.png", alt: "Biology", title: "Biology", group: "Biology" },
    { id: 18, src: "images/gallery/biology-24.png", alt: "Biology", title: "Biology", group: "Biology" },
  ];

  useEffect(() => {
    NativeFancybox.bind("[data-fancybox='gallery']", {
      infinite: true,
      Toolbar: {
        display: {
          left: ["infobar"],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        autoStart: false,
      },
      caption: (fancybox, slide) => {
        return slide.$trigger?.dataset?.caption || slide.$trigger?.title || "";
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);


  return (
    <>
      <Breadcrumb
        pageTitle="Gallery"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Biology Photo" },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <h2>Biology Photo</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="my-shuffle-container row columns-3 popup-gallery full-screen">
                {images.map((image) => (
                  <div key={image.id} className="grid-item" data-group={image.group}>
                    <div className="portfolio-item">
                      <div className="position-relative">
                        <img
                          className="img-fluid"
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                        />
                        <div className="portfolio-overlay">
                          <a
                            data-fancybox="gallery"
                            data-caption={image.title}
                            href={image.src}
                            title={image.title}
                            className="portfolio-img"
                          >
                            <i>
                              <BiPlusCircle size={40} />
                            </i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BiologyPhoto;
